import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import CheckCircleIcon from '../../../../icons/check-circle.svg';
import SvgIcon from '@material-ui/core/SvgIcon';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import Tooltip from '@material-ui/core/Tooltip';
import './ButtonInput.scss';
import { withStyles } from '@material-ui/core/styles';
import { SelectInput } from "../../../Helpers/Inputs";
import InfoIcon from '@material-ui/icons/Info';
import { Form } from 'react-bootstrap';

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

export default function ButtonInputForPolicy(props) {
    return (
        <Button
            variant={props.value ? 'outlined' : 'contained'}
            className={`shadow button-input-policy ${props.value ? 'active mt-4 pt-0' : 'inactive mt-4 pt-0'} ${props.mobileWide ? 'wide-sm' : ''}`}
            onClick={props.onClick}
            aria-pressed={props.value}
            aria-labelledby={props.title}
        >
            <span className='w-100 spanHeight'>
                <SvgIcon fontSize="large" component={props.icon} className={props.infoText ? 'icons mr-0' : 'icons'} />
                {props.infoText &&
                    <Tooltip title={props.infoText} className='float-right mx-0'>
                        <LightTooltip >
                            <InfoIcon color="action"></InfoIcon>
                        </LightTooltip>
                    </Tooltip>
                }
                <h2 className="title mx-2 mb-2">{props.title}</h2>
                <p className='subtitle'>{props.subtitle}</p>
                {
                    props.isFirstIndex(props.index) ?
                        <Form.Group className='px-2'>
                            <SelectInput
                                name="benefitAmount"
                                id="benefitAmount"
                                value={props.benefitAmount}
                                onChange={e => props.handleDropDownChange('benefitAmount', e.target.value)}
                                label="Benefit Amount"
                                selectOptions={[
                                    { label: "$5000", value: "5000" },
                                    { label: "$10000", value: "10000" },
                                    { label: "$15000", value: "15000" },
                                    { label: "$20000", value: "20000" },
                                    { label: "$25000", value: "25000" },
                                    { label: "$30000", value: "30000" },
                                    { label: "$35000", value: "35000" }]}

                                    className='ddArrow'
                            //errors={errors.collateralAssignment}
                            />
                        </Form.Group>
                        : null
                }
                <div className='absolute-div'>
                    {
                        props.value ?
                            <SvgIcon onClick={()=>props.handleValueChange(!props.value,props.index)} component={CheckCircleIcon} color="primary" name={props.productName} className="check" style={{ cursor: 'pointer' }} /> :
                            <SvgIcon onClick={()=>props.handleValueChange(!props.value,props.index)} component={RadioButtonUncheckedIcon} color="disabled" style={{ cursor: 'pointer' }} />
                    }
                </div>
            </span>
        </Button>
    );
}

ButtonInputForPolicy.propTypes = {
    icon: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.object
    ]).isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    value: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    mobileWide: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/components/Product/TermLifeInsurance/SubComponent/ButtonInputForPolicy.js